let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("e21Go")).then(() => parcelRequire('8Zrzn'));